import React, { useEffect, useState } from 'react';
import { Modal } from '@storaensods/se-design-system';
import icons from './../../../icons.svg';

import { Button } from '../../common/utils';

const MultipleProdutsSlots = ({
  isOpen,
  close,
  cabinetActions,
  cabinetSlotData,
  shelfNumber,
  allProducts,
  t,
  cabinet,
  scaleShelves = [],
}) => {
  const [selectedItemCount, setSelectedItemCount] = useState(0);

  const handleProductCountChange = type => {
    if (type === 'plus') {
      setSelectedItemCount(selectedItemCount + 1);
    } else {
      setSelectedItemCount(selectedItemCount - 1);
    }
  };

  const scaleItems = Array.isArray(cabinet.currentItems)
    ? cabinet.currentItems.filter(i => i.shelf && i.slot && i.barcode)
    : [];

  let mergedScaleItem = scaleItems.reduce((acc, item) => {
    const existing = acc.find(
      x => x.shelf === item.shelf && x.slot === item.slot
    );

    if (existing) {
      existing.count++;
    } else {
      acc.push({ shelf: item.shelf, slot: item.slot, count: 1 });
    }

    return acc;
  }, []);

  let scaleItem = mergedScaleItem.find(
    i =>
      i.shelf === Number(shelfNumber) && i.slot === Number(cabinetSlotData.slot)
  );
  let itemCount = (scaleItem && scaleItem.count) || 0;

  useEffect(() => {
    setSelectedItemCount(itemCount);
  }, [itemCount]);

  let products =
    Array.isArray(cabinetSlotData.products) && cabinetSlotData.products.length
      ? cabinetSlotData.products
      : cabinetSlotData.productAssigned
      ? [cabinetSlotData.productAssigned]
      : [];

  products = products.reduce((accumulator, current) => {
    if (Object.keys(accumulator).includes(current)) {
      accumulator[current] = accumulator[current] + 1;
    } else {
      accumulator[current] = 1;
    }

    return accumulator;
  }, {});

  const getScaleCabinetNote = () => {
    if (cabinet.deviceSubTypeName !== 'scale') return;
    if (!scaleShelves.find(shelf => shelf.shelf === shelfNumber)) return;

    const { products, productAssigned } = cabinetSlotData;

    //if a product has been added in the planogram, but not yet calibrated to the slot show the attention message
    if (products && products[0] && !productAssigned) {
      return (
        <div className="planogram__modal-info">
          <svg className="planogram__slots-item-cube">
            <use xlinkHref={`${icons}#icon-balance-scale`}></use>
          </svg>
          <p>{t('common:slotNotAssigned')}</p>
        </div>
      );
    }
    //if a product in plangogram is different than the claibrated product show warning.
    if (
      products &&
      products[0] &&
      productAssigned &&
      products[0] !== productAssigned
    ) {
      return (
        <div className="planogram__modal-info planogram__modal-info--warn">
          <svg className="planogram__slots-item-cube">
            <use xlinkHref={`${icons}#icon-warning`}></use>
          </svg>
          <p>{t('common:productMismatched')}</p>
        </div>
      );
    }

    //if a product is assinged but not yet in the planogram, show warning too.
    if (productAssigned && products && !products[0]) {
      return (
        <div className="planogram__modal-info">
          <svg className="planogram__slots-item-cube">
            <use xlinkHref={`${icons}#icon-warning`}></use>
          </svg>
          <p>{t('common:productMissingInPlanogram')}</p>
        </div>
      );
    }

    // if product is not defined in planogram nor assigned in the  cabinet slot
    if (!products[0] && !productAssigned) {
      return (
        <div className="planogram__modal-info planogram__modal-info--empty">
          <svg className="planogram__slots-item-cube">
            <use xlinkHref={`${icons}#icon-balance-scale`}></use>
          </svg>
          <p>{t('common:productMissing')}</p>
        </div>
      );
    }
  };

  const isShelf = scaleShelves.some(
    p => p.shelf === Number(shelfNumber) && p.type === 'scale1'
  );

  return (
    <Modal
      active={isOpen}
      centered={true}
      size="md"
      className="planogram__modal"
      onClose={() => close()}
    >
      <div className="calibration__selected">
        <span className="calibration__selected-shelf">
          {t('common:shelf')}: {shelfNumber}
        </span>
        <span className="calibration__selected-slot">
          {t('common:slot')}: {cabinetSlotData.slot}
        </span>
      </div>
      <div className="planogram__modal-body">
        <ul className="planogram__modal-names">
          {Object.keys(products)
            .filter(productId => allProducts.find(p => p.id === productId))
            .map(id => {
              const selectedProduct = allProducts.find(
                product => product.id === id
              );
              return (
                <li key={selectedProduct.id}>
                  <div className="planogram__modal-product">
                    <img src={selectedProduct.imageUrl} alt="product" />
                    {products[id] && products[id] > 1 && (
                      <span>{products[id]}</span>
                    )}
                  </div>
                  <span>
                    <strong>{selectedProduct.name}</strong>
                  </span>
                  {(cabinet.deviceSubTypeName === 'scale' ||
                    cabinet.deviceSubTypeName === 'hybrid') &&
                    isShelf &&
                    cabinet.replenishment === 'off' && (
                      <div className="calibration__product-input">
                        <button
                          onClick={() => handleProductCountChange('minus')}
                        >
                          -
                        </button>
                        <input
                          type="numnber"
                          min={0}
                          max={2}
                          value={selectedItemCount}
                          disabled={true}
                          onChange={e => {}}
                        />
                        <button
                          onClick={() => handleProductCountChange('plus')}
                        >
                          +
                        </button>
                      </div>
                    )}
                  {(cabinet.deviceSubTypeName === 'scale' ||
                    cabinet.deviceSubTypeName === 'hybrid') &&
                    isShelf &&
                    cabinet.replenishment === 'off' && (
                      <button
                        className="calibration__selected"
                        onClick={() =>
                          cabinetActions.sendInventoryCorrection(
                            cabinet.deviceCode,
                            cabinet.group,
                            shelfNumber,
                            cabinetSlotData.slot,
                            selectedProduct.id,
                            selectedItemCount
                          )
                        }
                      >
                        <span className="calibration__selected-shelf">
                          {cabinet.inventoryCorrectionLoading === true
                            ? t('common:updating')
                            : t('common:updateSlotInventory')}
                        </span>
                      </button>
                    )}
                </li>
              );
            })}
        </ul>
      </div>
      {(cabinet.deviceSubTypeName === 'scale' ||
        cabinet.deviceSubTypeName === 'hybrid') &&
        getScaleCabinetNote()}
      <div className="planogram__modal-footer">
        <Button type="close" onClick={() => close()} />
      </div>
    </Modal>
  );
};

export default MultipleProdutsSlots;
